import { useState } from "react";

interface UseDialogStateOptions {
  initialOpen?: boolean;
  onClose?: () => void;
}

/**
 * Custom hook for managing dialog open/close state with optional callback.
 * Standardizes dialog state management across the application.
 */
export const useDialogState = (options: UseDialogStateOptions = {}) => {
  const { initialOpen = false, onClose } = options;

  // Convert to boolean to handle truthy/falsy values
  const initialBooleanOpen = Boolean(initialOpen);

  const [open, setOpen] = useState(initialBooleanOpen);

  const handleOpenChange = (newOpen: boolean) => {
    setOpen(newOpen);

    // Call onClose callback when dialog is being closed
    if (!newOpen && onClose) {
      onClose();
    }
  };

  const openDialog = () => setOpen(true);
  const closeDialog = () => handleOpenChange(false);

  return {
    open,
    setOpen,
    handleOpenChange,
    openDialog,
    closeDialog,
  };
};
